import type { InputOption } from "@v1/components/editor/page/element-editor/components/modifiers/LengthInputModifier";

import * as React from "react";

import ButtonGroupComponent from "@v1/components/common/designSystem/ButtonGroup";
import { LengthInputSelector } from "@v1/components/editor/page/element-editor/components/modifiers/LengthInputModifier";
import { Minus, Plus } from "lucide-react";

type StepperProps = {
  onChange(value: number): void;
  placeholder?: string;
  value: number;
  testIdPlus?: string;
  testIdMinus?: string;
  field: string;
  startEnhancer?: React.ReactNode;
  menuOptions?: InputOption[];
  toolTipPlusButton?: string;
  toolTipMinusButton?: string;
  resetValue?: string;
  anchorValue?: string;
  minDragValue?: number;
  minValue?: number;
};

const options = [{ label: "Reset", value: "0" }];

const Stepper: React.FC<StepperProps> = (props) => {
  return (
    <div className="flex flex-row items-end justify-between gap-2">
      <LengthInputSelector
        startEnhancer={props.startEnhancer}
        value={String(props.value)}
        placeholder={props.placeholder ?? "0"}
        key={props.field}
        field={props.field}
        onChange={(value) => {
          props.onChange(Number(value));
        }}
        minDragValues={{ "": props.minDragValue ?? 0 }}
        minValues={{ "": props.minValue ?? 0 }}
        dragTrigger="startEnhancer"
        metrics={[""]}
        resetValue={props.resetValue ?? "0"}
        anchorValue={props.anchorValue ?? "0"}
        allowsNegativeValue={true}
        menuOptions={props.menuOptions ?? options}
        draggingType="vertical"
      />
      <ButtonGroupComponent
        options={[
          {
            label: <Minus size={12} data-testid={props.testIdMinus} />,
            onClick: () => {
              props.onChange(
                Math.max(
                  props.value - 1,
                  props.minValue ?? props.minDragValue ?? 0,
                ),
              );
            },
            tooltipText: props.toolTipMinusButton,
          },
          {
            label: <Plus size={12} data-testid={props.testIdPlus} />,
            onClick: () => {
              props.onChange(props.value + 1);
            },
            tooltipText: props.toolTipPlusButton,
          },
        ]}
      />
    </div>
  );
};

export default Stepper;
